/**
 * Largeur fixe proposal (box.width / colonnes) + alignement horizontal.
 */

import { gridUnit } from '../../constants/gridConfig';
import { normalizeHorizontalAlign } from './proposalBoxAlign';

/** Largeur canvas proposal (px). */
export const PROPOSAL_PAGE_WIDTH_PX = 825;

const DEFAULT_MARGINS = { left: 7, right: 7 };

/**
 * Largeur utile contenu proposal : page − marges (comme calculateWidth factor 0).
 */
export function computeProposalContentWidthPx(configuration = {}) {
  const margins = configuration?.margins || DEFAULT_MARGINS;
  const left = (Number(margins.left) || 0) * gridUnit;
  const right = (Number(margins.right) || 0) * gridUnit;
  return PROPOSAL_PAGE_WIDTH_PX - left - right;
}

/**
 * Largeur tableau legacy : somme des colonnes, sinon box.width.
 * @param {object} box
 * @returns {number|null}
 */
export function resolveProposalTableWidthPx(box) {
  const cols = box?.content?.columns;
  if (Array.isArray(cols) && cols.length > 0) {
    const sum = cols.reduce((acc, col) => {
      const w = Number(col?.width);
      return acc + (Number.isFinite(w) && w > 0 ? w : 0);
    }, 0);
    if (sum > 0) return sum;
  }
  const boxW = Number(box?.width);
  if (Number.isFinite(boxW) && boxW > 0) return boxW;
  return null;
}

/**
 * Ratio largeur tableau flux legacy : contenu utile / page (ex. 755/825 ≈ 91,5 %).
 */
export function resolveProposalTableWidthRatio(projectConfig = null) {
  const contentPx = projectConfig?.proposalContentWidthPx
    ?? computeProposalContentWidthPx(
      projectConfig?.margins ? { margins: projectConfig.margins } : {},
    );
  return contentPx / PROPOSAL_PAGE_WIDTH_PX;
}

/**
 * Largeur tableau web = même ratio que le proposal, appliqué à la colonne.
 * (755px sur 825px → ~91,5 % de la largeur dispo, centré si besoin.)
 */
export function buildProposalTableLayoutCss({
  widthRatio,
  horizontal = 'center',
}) {
  const ratio = Number(widthRatio);
  if (!Number.isFinite(ratio) || ratio <= 0) return {};

  const widthPercent = `${Math.round(Math.min(1, ratio) * 10000) / 100}%`;
  const h = normalizeHorizontalAlign(horizontal);
  const layout = {
    width: widthPercent,
    maxWidth: '100%',
    boxSizing: 'border-box',
  };

  if (h === 'end') {
    return { ...layout, marginLeft: 'auto', marginRight: 0 };
  }
  if (h === 'center') {
    return { ...layout, marginLeft: 'auto', marginRight: 'auto' };
  }
  return layout;
}

/**
 * @deprecated préférer {@link buildProposalTableLayoutCss}
 */
export function buildProposalFixedWidthLayoutCss({
  widthPx,
  horizontal = 'left',
  drawMode = false,
}) {
  const n = Number(widthPx);
  if (!Number.isFinite(n) || n <= 0) return {};

  const widthCss = `${n}px`;
  const h = normalizeHorizontalAlign(horizontal);
  const layout = {
    width: '100%',
    maxWidth: widthCss,
    boxSizing: 'border-box',
  };

  if (h === 'end') {
    return { ...layout, marginLeft: 'auto', marginRight: 0 };
  }
  if (h === 'center') {
    return { ...layout, marginLeft: 'auto', marginRight: 'auto' };
  }
  return layout;
}
